<template>
  <div
    class="order-wrapper"
    @click="nameClick"
  >
    <span>
      {{ name }}
      <el-tooltip
        v-if="tip"
        effect="dark"
        placement="top"
      >
        <div slot="content">
          {{ tip }}
        </div>
        <i class="eqf-why-f"></i>
      </el-tooltip>
    </span>
    <span
      v-if="orders.length"
      class="icon-wrapper"
      :class="{ active: sortOrder.order == 0 }"
    >
      <!-- <i
        :class="{ active: sortOrder.order == 0 }"
        class="sort-caret asc"
        @click="sort(0)"
      ></i>
      <i
        :class="{ active: sortOrder.order == 1 }"
        class="sort-caret desc"
        @click="sort(1)"
      ></i> -->
      <svg-icon
        icon-class="sort"
        class-name="sort-icon"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: 'Order',
  props: {
    name: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    orders: {
      type: Array,
      default: function() {
        return []
      }
    },
    defaultOrder: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      sortOrder: this.defaultOrder
    }
  },
  methods: {
    nameClick() {
      if (this.sortOrder.order === 0) {
        this.sortOrder.order = 1
      } else if (this.sortOrder.order === 1) {
        this.sortOrder.order = 0
      } else {
        this.sortOrder.order = 1
      }
      this.$emit(
        'change',
        this.orders[this.sortOrder.order],
        this.sortOrder.sort_key
      )
    },
    sort(type, index) {
      this.sortOrder.order = type
      this.$emit(
        'change',
        this.orders[this.sortOrder.order],
        this.sortOrder.sort_key
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.order-wrapper {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.icon-wrapper {

  .sort-icon {
    font-size: 16px;
  }

  &.active .sort-icon {
    transform: rotate(180deg);
  }
}
</style>
